import {useState} from 'react'
import {Button} from '@primer/react-brand'
import {LinkIcon} from '@primer/octicons-react'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import Styles from './ShareButton.module.css'

type Props = {
  id: string
  location: string
}

export function ShareButton(props: Props) {
  const {id, location} = props
  const [copied, setCopied] = useState(false)
  const href = `/events/universe/recap/#${id}`

  const handleClick = async () => {
    try {
      const fullUrl = `${window.location.origin}${href}`
      await navigator.clipboard.writeText(fullUrl)
      setCopied(true)
      setTimeout(() => {
        setCopied(false)
      }, 1000)
    } catch {
      // Silently fail - clipboard write may be blocked by browser permissions
    }
  }

  return (
    <Button
      className={Styles.ShareButton}
      as="button"
      onClick={handleClick}
      variant="subtle"
      size="small"
      leadingVisual={<LinkIcon />}
      hasArrow={false}
      aria-label={copied ? 'Link copied to clipboard' : 'Share this section'}
      {...getAnalyticsEvent({
        action: 'click',
        tag: 'button',
        context: 'share_button',
        location,
      })}
    >
      <span className={Styles.Text}>{copied ? 'Copied!' : 'Share'}</span>
    </Button>
  )
}

try{ ShareButton.displayName ||= 'ShareButton' } catch {}